import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	welcome: {
		id: 'onboarding.stress.welcome.full',
		defaultMessage: 'Welcome to {Calm}',
		description: 'Heading welcoming user to flow',
	},
	congratulations: {
		id: 'onboarding.stress.congratulations',
		defaultMessage:
			'<bold>Congratulations</bold> on taking the first step towards a <bold>mentally stronger you</bold>.',
		description: 'Copy telling the user why they should sign up',
	},
	getStarted: {
		id: 'onboarding.stress.getStarted',
		defaultMessage: 'Let’s get started! Just a few questions to <bold>personalize</bold> your experience.',
		description: 'Copy telling the user why they should sign up',
	},
});
